document.addEventListener('DOMContentLoaded', () => {
  function initialiseProducts(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialised) return;
      section.dataset.initialised = 'true';
      const select = section.querySelector('[data-variant-select]');
      const variants = JSON.parse(section.querySelector('[data-variants]').textContent);
      const button = section.querySelector('[data-add-button]');
      const quantity = section.querySelector('[data-product-quantity]');
      select.addEventListener('change', () => {
        const variant = variants.find(v => String(v.id) === select.value);
        if (!variant) return;
        section.querySelector('[data-price]').textContent = variant.price;
        section.querySelector('[data-unit-price]').textContent = variant.unitPrice;
        button.disabled = !variant.available || !variant.priced;
        button.textContent = !variant.priced ? button.dataset.labelUnpriced : variant.available ? button.dataset.labelAdd : button.dataset.labelSold;
        quantity.min = variant.minimum;
        quantity.step = variant.increment;
        if (variant.maximum) quantity.max = variant.maximum;
        else quantity.removeAttribute('max');
        const old = Number(quantity.value);
        let next = Math.max(variant.minimum, Math.ceil(old / variant.increment) * variant.increment);
        if (variant.maximum) next = Math.min(next, variant.maximum);
        quantity.value = next;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      });
    });
  }
  initialiseProducts();
  document.addEventListener('shopify:section:load', e => initialiseProducts(e.target));
  document.querySelectorAll('.mobile-menu a').forEach(link => link.addEventListener('click', () => {
    link.closest('details').removeAttribute('open');
  }));
});
